module.exports = __webpack_public_path__ + "img/frame4.e6d18261.jpg";